module.exports = __webpack_public_path__ + "static/media/Triangle.870dd028.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/claims/details/Triangle.png
// module id = 2099
// module chunks = 147